module.exports = __webpack_public_path__ + "static/media/unionpay.f2024452.svg";